import { useState } from 'react';
import { Icon } from '@iconify/react';
import { Link, useLocation } from 'react-router-dom';

const Sidebar = ({ sidebarOpen }) => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const location = useLocation();

  const toggleDropdown = (index) => {
    setOpenDropdown(openDropdown === index ? null : index);
  };

  const isActive = (path) => location.pathname === path;
  
  const handleMobileSidebarToggle = () => {
    const sidebar = document.getElementsByClassName("sidebar")[0];
    const body = document.body;

    sidebar.classList.toggle("sidebar-open");
    body.classList.toggle("overlay-active");
  };
  return (
    <aside className={`sidebar ${!sidebarOpen ? 'active' : ''}`}>
      <button type="button" className="sidebar-close-btn" onClick={handleMobileSidebarToggle}>
        <Icon icon="radix-icons:cross-2" />
      </button>

      <div>
        <Link to="/index" className="sidebar-logo">
          <img src="/images/logo.png" alt="site logo" className="light-logo" />
          <img src="/images/logo-light.png" alt="site logo" className="dark-logo" />
          <img src="/images/logo-icon.png" alt="site logo" className="logo-icon" />
        </Link>
      </div>

      <div className="sidebar-menu-area">
        <ul className="sidebar-menu" id="sidebar-menu">
          <li><Link className={isActive('dashboard') ? 'active' : ''} to="admin/dashboard"><Icon icon="solar:home-smile-angle-outline" className="menu-icon" /><span>Dashboard</span></Link></li>
          <li className="sidebar-menu-group-title">Module</li>
          <li className={`dropdown ${openDropdown === 0 ? 'open' : ''}`}> 
            <Link href="#" onClick={() => toggleDropdown(0)}>
              <Icon icon="solar:home-smile-angle-outline" className="menu-icon" />
              <span>Syllabus Tracking</span>
            </Link>
            {openDropdown === 0 && (
              <ul className="sidebar-submenu">
                <li><Link className={isActive('/admin/chapter-master') ? 'active' : ''} to="/admin/chapter-master"><Icon icon="ri-group-fill" className="menu-icon" /> Chapter Master</Link></li>
                {/*<li><Link className={isActive('/admin/topic-master') ? 'active' : ''} to="/admin/topic-master"><Icon icon="ri-group-fill" className="menu-icon" /> Topic Master</Link></li>*/}
                <li><Link className={isActive('/admin/add-syllabus') ? 'active' : ''} to="/admin/add-syllabus"><Icon icon="ri-group-fill" className="menu-icon" /> Add Syllabus</Link></li> 
                <li><Link className={isActive('/admin/syllabus-tracking-report') ? 'active' : ''} to="/admin/syllabus-tracking-report"><Icon icon="ri-group-fill" className="menu-icon" /> Report : Syllabus Tracking</Link></li>
              </ul>
            )}
          </li>
          <li className={`dropdown ${openDropdown === 1 ? 'open' : ''}`}> 
            <Link href="#" onClick={() => toggleDropdown(1)}>
              <Icon icon="solar:home-smile-angle-outline" className="menu-icon" />
              <span>Enquiry Report</span>
            </Link>
            {openDropdown === 1 && (
              <ul className="sidebar-submenu">
                <li><Link className={isActive('/admin/enquiry-report') ? 'active' : ''} to="/admin/enquiry-report"><Icon icon="ri-group-fill" className="menu-icon" /> Report : Enquiry</Link></li>
              </ul>
            )}
          </li>

          {/* <li className="sidebar-menu-group-title">Application</li>
          <li><Link className={isActive('/email') ? 'active' : ''} to="/email"><Icon icon="mage:email" className="menu-icon" /><span>Email</span></Link></li>
          <li><Link className={isActive('/chat') ? 'active' : ''} to="/chat"><Icon icon="bi:chat-dots" className="menu-icon" /><span>Chat</span></Link></li>
          <li><Link className={isActive('/calendar') ? 'active' : ''} to="/calendar"><Icon icon="solar:calendar-outline" className="menu-icon" /><span>Calendar</span></Link></li>

          <li className={`dropdown ${openDropdown === 1 ? 'open' : ''}`}>
            <a href="#" onClick={() => toggleDropdown(1)}>
              <Icon icon="basil:invoice-outline" className="menu-icon" />
              <span>Invoice</span>
            </a>
            {openDropdown === 1 && (
              <ul className="sidebar-submenu">
                <li><Link className={isActive('/invoice/list') ? 'active' : ''} to="/invoice/list">Invoice List</Link></li>
                <li><Link className={isActive('/invoice/details') ? 'active' : ''} to="/invoice/details">Invoice Details</Link></li>
                <li><Link className={isActive('/invoice/create') ? 'active' : ''} to="/invoice/create">Create Invoice</Link></li>
                <li><Link className={isActive('/invoice/edit') ? 'active' : ''} to="/invoice/edit">Edit Invoice</Link></li>
              </ul>
            )}
          </li>

          <li className={`dropdown ${openDropdown === 2 ? 'open' : ''}`}>
            <a href="#" onClick={() => toggleDropdown(2)}>
              <Icon icon="tabler:users" className="menu-icon" />
              <span>Users</span>
            </a>
            {openDropdown === 2 && (
              <ul className="sidebar-submenu">
                <li><Link className={isActive('/users/list') ? 'active' : ''} to="/users/list">Users List</Link></li>
                <li><Link className={isActive('/users/profile') ? 'active' : ''} to="/users/profile">User Profile</Link></li>
                <li><Link className={isActive('/users/edit') ? 'active' : ''} to="/users/edit">Edit Profile</Link></li>
              </ul>
            )}
          </li>

          <li className={`dropdown ${openDropdown === 3 ? 'open' : ''}`}>
            <a href="#" onClick={() => toggleDropdown(3)}>
              <Icon icon="mdi:form-select" className="menu-icon" />
              <span>Forms</span>
            </a>
            {openDropdown === 3 && (
              <ul className="sidebar-submenu">
                <li><Link className={isActive('/forms/basic') ? 'active' : ''} to="/forms/basic">Basic Elements</Link></li>
                <li><Link className={isActive('/forms/advanced') ? 'active' : ''} to="/forms/advanced">Advanced Elements</Link></li>
                <li><Link className={isActive('/forms/layout') ? 'active' : ''} to="/forms/layout">Form Layout</Link></li>
              </ul>
            )}
          </li>

          <li className={`dropdown ${openDropdown === 4 ? 'open' : ''}`}>
            <a href="#" onClick={() => toggleDropdown(4)}>
              <Icon icon="mdi:table" className="menu-icon" />
              <span>Tables</span>
            </a>
            {openDropdown === 4 && (
              <ul className="sidebar-submenu">
                <li><Link className={isActive('/tables/basic') ? 'active' : ''} to="/tables/basic">Basic Tables</Link></li>
                <li><Link className={isActive('/tables/data') ? 'active' : ''} to="/tables/data">Data Tables</Link></li>
              </ul>
            )}
          </li>

          <li className={`dropdown ${openDropdown === 5 ? 'open' : ''}`}>
            <a href="#" onClick={() => toggleDropdown(5)}>
              <Icon icon="mdi:chart-bar" className="menu-icon" />
              <span>Charts</span>
            </a>
            {openDropdown === 5 && (
              <ul className="sidebar-submenu">
                <li><Link className={isActive('/charts/apex') ? 'active' : ''} to="/charts/apex">Apex Charts</Link></li>
                <li><Link className={isActive('/charts/chartjs') ? 'active' : ''} to="/charts/chartjs">Chart JS</Link></li>
              </ul>
            )}
          </li>
           */}  
        </ul>
      </div>
    </aside>
  );
};

export default Sidebar;
